(function () {
  if (customElements.get("gift-threshold-banner")) return;

  class GiftThresholdBanner extends HTMLElement {
    constructor() {
      super();
      this.threshold = parseInt(this.dataset.threshold, 10) || 250000;
      this.isLoggedIn = this.dataset.loggedIn === "true";
      this._onCartUpdate = this._onCartUpdate.bind(this);
    }

    connectedCallback() {
      this._fetchAndEvaluate();

      this._observer = new MutationObserver(() => this._fetchAndEvaluate());
      const drawerBody = document.querySelector("[data-cart-drawer-body]");
      if (drawerBody) {
        this._observer.observe(drawerBody, { childList: true, subtree: true });
      }

      document.addEventListener("cart:updated", this._onCartUpdate);
      document.addEventListener("cart:refresh", this._onCartUpdate);
      document.addEventListener("cart:build", this._onCartUpdate);
      document.addEventListener("cart-items:updated", this._onCartUpdate);
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
      document.removeEventListener("cart:updated", this._onCartUpdate);
      document.removeEventListener("cart:refresh", this._onCartUpdate);
      document.removeEventListener("cart:build", this._onCartUpdate);
      document.removeEventListener("cart-items:updated", this._onCartUpdate);
    }

    _onCartUpdate(event) {
      const cart = event && event.detail && event.detail.cart;
      if (cart && typeof cart.total_price !== "undefined") {
        this._evaluate(cart.total_price);
      } else {
        this._fetchAndEvaluate();
      }
    }

    _fetchAndEvaluate() {
      const cartUrl =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root + "cart.js"
          : "/cart.js";

      fetch(cartUrl, { credentials: "same-origin" })
        .then((res) => res.json())
        .then((cart) => this._evaluate(cart.total_price))
        .catch(() => {});
    }

    _evaluate(totalPriceCents) {
      const shouldShow = !this.isLoggedIn && totalPriceCents >= this.threshold;
      this.classList.toggle("gift-threshold-banner--visible", shouldShow);
    }
  }

  customElements.define("gift-threshold-banner", GiftThresholdBanner);
})();
